import ifsUserReducer from "./ifsUserSlice";

export default ifsUserReducer;
export { default as ifsUserSlice } from "./ifsUserSlice";
export { fetchIfsUserDetails, clearIfsUser } from "./ifsUserSlice";
